import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import service from './api/index'

Vue.use(ElementUI)


Vue.prototype.$axios = service

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')